import DismissiblePill from '@ulta/core/components/DismissiblePill/DismissiblePill';

export default DismissiblePill;